import { apiClient } from "./Client";
 
const apiGet = (endPoint, data = {}) => {
  return apiClient()
    .get(endPoint, data)
    .then((res) => {
      if (res?.status === 401) {
        //Refresh auth token
      }
      return res?.data;
    })
    .catch((err) => {
      return err.message;
    });
};
 
const apiPost = (endPoint, data, headers = {}) => {
  return apiClient()
    .post(endPoint, data, {
      headers: {
        ...headers,
        "Content-Type": headers["Content-Type"] || "application/json", // Default to JSON if not specified
      },
    })
    .then((res) => {
      if (res?.status === 401) {
        // Handle token refresh logic here
        // Refresh auth token and retry the request
      }
      return res;
    })
    .catch((err) => {
      // Return structured error or throw it
      console.log("API Post Error:", err);
      return {
        status: false,
        message:
          err.response?.data || err.message || "An unknown error occurred.",
      };
    });
};
 
const apiPut = (endPoint, data) => {
 
  return apiClient()
    .put(endPoint, data)
    .then((res) => {
      if (res?.status === 401) {
        //Refresh auth token
      }
      return res;
    })
    .catch((err) => {
      // console.log("API error in apiPut:", err);
      // return err.message;
      console.log("API error:", err);
      if (err.response) {
        console.log("Error response data:", err.response.data);
        console.log("Error response status:", err.response.status);
      } else if (err.request) {
        console.log("Error request data:", err.request);
      } else {
        console.log("Error message:", err.message);
      }
      return Promise.reject(err);
    });
};
 
const apiDelete = (endPoint, data) => {
  return apiClient()
    .delete(
      endPoint,
      {},
      {
        data: data,
      }
    )
    .then((res) => {
      if (res?.status === 401) {
        //Refresh auth token
      }
      return res;
    })
    .catch((err) => {
      return err.message;
    });
};
 
// const apiDelete = (endPoint, data = {}) => {
//   return apiClient()
//     .delete(endPoint, {
//       data: data,
//       headers: {
//         "Content-Type": "application/json", // optional
//       },
//     })
//     .then((res) => {
//       if (res?.status === 401) {
//         // Refresh auth token logic
//       }
//       return res;
//     })
//     .catch((err) => {
//       console.log("API DELETE Error:", err);
//       return {
//         status: false,
//         message:
//           err.response?.data || err.message || "An unknown error occurred.",
//       };
//     });
// };

// const apiDelete = (endPoint, data) => {
//   return apiClient()
//     .delete(endPoint, {
//       data: data,
//     })
//     .then((res) => {
//       if (res?.status === 401) {
//         // Refresh token logic
//       }
//       return res;
//     })
//     .catch((err) => {
//       return err.message;
//     });
// };
export { apiGet, apiPost, apiPut, apiDelete };